import { render, staticRenderFns } from "./ShowLaundryTypes.vue?vue&type=template&id=225cc853&"
import script from "./ShowLaundryTypes.vue?vue&type=script&lang=js&"
export * from "./ShowLaundryTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports